import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GetSiteGQL, GetArticlesGQL, DeletePartnerPageGQL } from '../../graphql/graphql';
import { ToastService } from '../../shared/toast/toast.service';

@Component({
    selector: 'app-articles',
    templateUrl: './articles.component.html',
    styleUrls: ['./articles.component.scss'],
    standalone: false
})
export class ArticlesComponent implements OnInit {
  siteUrl: string = '';
  siteId: string = '';
  articles: any[] = [];
  loading = true;
  showDeleteModal = false;
  articleToDelete: any = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private getSiteGQL: GetSiteGQL,
    private getArticlesGQL: GetArticlesGQL,
    private deletePartnerPageGQL: DeletePartnerPageGQL,
    private toast: ToastService
  ) {}

  ngOnInit() {
    this.siteUrl = this.route.parent?.snapshot.params['url'] || '';
    this.loadSiteData();
  }

  loadSiteData() {
    if (this.siteUrl) {
      this.getSiteGQL.watch({ variables: { url: this.siteUrl, categoryId: '' } }).valueChanges.subscribe(result => {
        if (result.data?.site) {
          this.siteId = result.data.site._id!;
          this.getArticlesGQL.watch({ variables: { siteId: this.siteId, type: 'article' }, fetchPolicy: 'network-only' }).valueChanges.subscribe(r => {
            this.loading = false;
            if (r.data?.partnerPages) {
              this.articles = r.data.partnerPages.map(a => ({ ...a }));
            }
          });
        }
      });
    }
  }

  addArticle() {
    this.router.navigate(['article'], { relativeTo: this.route });
  }

  editArticle(id: string) {
    this.router.navigate(['article', id], { relativeTo: this.route });
  }

  confirmDelete(article: any) {
    this.articleToDelete = article;
    this.showDeleteModal = true;
  }

  cancelDelete() {
    this.showDeleteModal = false;
    this.articleToDelete = null;
  }

  deleteArticle() {
    if (this.articleToDelete) {
      this.deletePartnerPageGQL.mutate({
        variables: { id: this.articleToDelete._id },
        refetchQueries: [{ query: this.getArticlesGQL.document, variables: { siteId: this.siteId, type: 'article' } }]
      }).subscribe({
        next: () => {
          this.showDeleteModal = false;
          this.articleToDelete = null;
          this.toast.success('Article deleted');
        },
        error: () => this.toast.error('Error deleting article')
      });
    }
  }

  get orderedArticles() {
    return [...this.articles].sort((a, b) => {
      if (a.articleDate && b.articleDate) return new Date(b.articleDate).getTime() - new Date(a.articleDate).getTime();
      return a.name.localeCompare(b.name);
    });
  }
}
